import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { ROUTE_PATH } from "../../helper/Constants";
import { isMobile } from "react-device-detect";

const AppDownload = () => {
  const [t] = useTranslation();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      onClose={handleClose}
      open={isMobile && open}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle
        sx={{
          backgroundColor: "#ffc115cb",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" component="span">
            {t("app-download.head")}
          </Typography>
          <IconButton aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={{ padding: 1 }}>
        <Box sx={{ padding: "10px" }}>
          {t("app-download.text1")}
          <Link
            to={window.location.origin + ROUTE_PATH.ANDROID_APP}
            target="_blank"
            about="_blank"
            onClick={handleClose}
          >
            {t("app-download.text2")}
          </Link>
          .
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AppDownload;
